import { gql } from '@apollo/client'

export const GET_DXO_EXECUTION_BY_PRIORITY_LEVEL = gql`
  query GetDXOExecutionByPriorityLevel($input: AdminDashboardCommonInput!) {
    dxoExecutionByPriorityLevel(input: $input) {
      priorityLevel
      numPriorities
      numCompliant
    }
  }
`
